import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";

import { useLocale } from "@seller/app/locale";

const AccountPage = lazy(() => import("@/modules/account/pages/AccountPage").then(module => ({ default: module.AccountPage })));

function AccountRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <AccountPage locale={locale} storeSlug={storeSlug} />;
}

export const accountRoutes: RouteObject[] = [
  {
    path: "account",
    element: <RouteSuspense><AccountRoute /></RouteSuspense>,
  },
];
